// Video upload limits: the numbers the server enforces and the upload hint
// prints. Agreed with Kurtis 2026-10-14 (docs/plans/VIDEO_PLAN.md §11, §12).
//
// CommonJS and under `src/config` on purpose, like holidayCalendar.js: the
// server (server/services/videoUploadService.js) requires it, and
// src/utils/mediaUploadSpecs.js imports it to build VIDEO_SPECS, so the help
// text can't promise a limit the server doesn't enforce.
//
// Keep module scope boring: webpack infers the named exports from the literal
// `module.exports = { … }` below and gives up on spreads or computed objects
// (see the note in holidayCalendar.js).

/**
 * Where video is in its rollout. The upload hint and the server's dark gate
 * both read it:
 *
 *   'hidden'      — say nothing about video
 *   'coming_soon' — the hint shows the guidance, badged; the upload API
 *                   answers admins only
 *   'live'        — the guidance is binding and everyone can upload
 *
 * Flip to 'live' in the same commit that ships the upload UI (VIDEO_PLAN §7, V8).
 */
const VIDEO_STATUS = 'coming_soon';

const GiB = 1024 * 1024 * 1024;

const VIDEO_LIMITS = {
  // Per clip (§11).
  maxSeconds: 600,
  maxBytes: 4 * GiB,
  // "2160p": the short edge, so a vertical 4K clip (2160 × 3840) fits.
  maxShortEdge: 2160,
  // Per user: minutes uploaded in a rolling window. Counted when an upload
  // starts; deleting a finished clip doesn't give them back. An upload that
  // is cancelled or expires before it finishes does.
  monthlyMinutes: 60,
  windowDays: 30,
  // Throughput per user.
  uploadsInFlight: 2,
  uploadsPerHour: 20,
  // What the picker may send. MP4 and MOV cover iPhone, Android and the
  // desktop editors; the encoder (V3) probes the real codec.
  acceptedContentTypes: ['video/mp4', 'video/quicktime']
};

module.exports = {
  VIDEO_STATUS,
  VIDEO_LIMITS
};
